/** @jsx jsx */
import { Global, jsx, css } from "@emotion/core";
import { Component } from "react";
import { Fragment } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { connect } from "react-redux";
import Note from "./Note";
import EditNote from "../notes/EditNote";
import { IconContext } from "react-icons";
import { MdModeEdit, MdKeyboardArrowDown, MdDeleteSweep } from "react-icons/md";
import { UncontrolledCollapse, CardBody, Card } from "reactstrap";
import { removeNote } from "../../actions/notesActions";

class NoteList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedNoteId: "",
      modal: false
    };

    this.handleSelect = this.handleSelect.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
  }

  handleSelect(id) {
    this.setState({
      selectedNoteId: id,
      modal: !this.state.modal
    });
  }

  toggleModal() {
    this.setState({
      modal: !this.state.modal
    });
  }

  render() {
    return (
      <div
        css={css`
          width: 100%;
          min-height: 58vh;
          background-color: rgb(242, 251, 253);
          overflow-y: scroll;
        `}
      >
        <Global
          styles={css`
            svg.icon {
              color: #f7c02d;
              width: 30px;
              height: 30px;
              cursor: pointer;
              &:hover {
                color: #ffffff;
              }
              &.icon-trash,
              &.icon-edit {
                width: 30px;
                height: 30px;
                color: #f7c02d;
              }
              &.icon-edit {
                height: 29px;
                padding-top: 2px;
              }
              &.icon-trash:hover {
                color: red;
              }
              &.icon-edit:hover {
                color: #040404;
              }
              &.icon-open {
                width: 40px;
                height: 30px;
                &:hover {
                  color: #040404;
                }
              }
            }
          `}
        />
        <TransitionGroup>
          {this.props.notes &&
            this.props.notes.map((note, index) => {
              const removeButton =
                this.props.auth.uid === note.authorId ? (
                  <IconContext.Provider
                    value={{ className: "icon icon-trash" }}
                  >
                    <MdDeleteSweep
                      onClick={id => this.props.removeNote(note.id)}
                    />
                  </IconContext.Provider>
                ) : null;

              const editButton =
                this.props.auth.uid === note.authorId ? (
                  <IconContext.Provider value={{ className: "icon icon-edit" }}>
                    <MdModeEdit onClick={() => this.handleSelect(note.id)} />
                  </IconContext.Provider>
                ) : null;

              return (
                <CSSTransition
                  timeout={500}
                  classNames="fade"
                  key={`${index}${note.noteContent}`}
                >
                  <Fragment key={index}>
                    <div
                      css={css`
                        position: relative;
                      `}
                    >
                      <div
                        key={index}
                        css={css`
                          color: #040404;
                        `}
                      >
                        <p
                          css={css`
                            padding-top: 20px;
                            position: relative;
                            margin-bottom: 0;
                          `}
                        >
                          <span id={`note${index}`}>
                            <IconContext.Provider
                              value={{
                                className: "icon icon-open"
                              }}
                            >
                              <MdKeyboardArrowDown />
                            </IconContext.Provider>
                          </span>
                          инст.№-{note.noteSetNumber} :{" "}
                          {note.noteTheme}
                          <span
                            css={css`
                              position: absolute;
                              right: 40px;
                            `}
                          >
                            {editButton}
                          </span>
                          <span
                            css={css`
                              position: absolute;
                              right: 5px;
                            `}
                          >
                            {removeButton}
                          </span>
                        </p>
                        <p
                          css={css`
                            color: #6c757d;
                            font-size: 0.9rem;
                            padding-left: 28px;
                          `}
                        >
                          <span>{note.created}</span>
                        </p>
                      </div>
                    </div>
                    <UncontrolledCollapse
                      toggler={`#note${index}`}
                    >
                      <Card>
                        <CardBody>
                          <Note
                            content={note.noteContent}
                            author={
                              note.authorFirstName +
                              " " +
                              note.authorLastName
                            }
                          />
                        </CardBody>
                      </Card>
                    </UncontrolledCollapse>
                  </Fragment>
                </CSSTransition>
              );
            })}
        </TransitionGroup>
        {this.state.selectedNoteId ? (
          <EditNote
            selectedId={this.state.selectedNoteId}
            modal={this.state.modal}
            toggle={this.toggleModal}
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    auth: state.firebase.auth
  };
};

const mapDispatchToProps = dispatch => {
  return {
    removeNote: id => dispatch(removeNote(id))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NoteList);
